import { render, staticRenderFns } from "./storageOrderListTableItem.vue?vue&type=template&id=5c5158a2&scoped=true&"
import script from "./storageOrderListTableItem.vue?vue&type=script&lang=js&"
export * from "./storageOrderListTableItem.vue?vue&type=script&lang=js&"
import style0 from "./storageOrderListTableItem.vue?vue&type=style&index=0&id=5c5158a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5158a2",
  null
  
)

export default component.exports